<script lang="ts">
  // A single suggested next move at a real decision point: one question, one
  // primary action, and the alternatives spelled out rather than hidden.
  // Deliberately not decorative — only mount this where the accept action
  // maps to a write path the user would otherwise perform by hand.
  const {
    question,
    detail,
    acceptLabel,
    onAccept,
    /** Secondary paths, including the "not now" escape hatch. */
    alternatives = [],
    /** 0..1. Renders a strip under the actions; omit for no strip. */
    strength,
    strengthLabel
  }: {
    question: string;
    detail?: string;
    acceptLabel: string;
    onAccept: () => void;
    alternatives?: Array<{ label: string; onSelect: () => void }>;
    strength?: number;
    strengthLabel?: string;
  } = $props();

  const pct = $derived(Math.round(Math.min(1, Math.max(0, strength ?? 0)) * 100));
</script>

<div class="tym-recommend">
  <div class="tym-recommend-q">{question}</div>
  {#if detail}
    <div class="tym-recommend-detail">{detail}</div>
  {/if}
  <div class="tym-recommend-actions">
    <button type="button" class="btn-primary !py-2 !text-[12.5px]" onclick={onAccept}>{acceptLabel}</button>
    {#each alternatives as alt (alt.label)}
      <button type="button" class="tym-recommend-alt" onclick={alt.onSelect}>{alt.label}</button>
    {/each}
  </div>
  {#if strength !== undefined}
    <span
      class="tym-recommend-strip"
      role="img"
      aria-label={`${strengthLabel ?? 'Strength'}: ${pct}%`}
    >
      <span style="width:{pct}%"></span>
    </span>
  {/if}
</div>
